import { CumulativeBoosterID } from "../cumulative_booster_id.js";
import { TimedCumulativeBooster } from "../timed_cumulative_booster.js";

export interface InfiniteBallsBoosterContext
{
  setInfiniteBallsActive( active: boolean ): void;
}

export class InfiniteBallsBooster extends TimedCumulativeBooster<InfiniteBallsBoosterContext>
{
  public static readonly DEFAULT_DURATION_SECONDS = 5;

  public constructor( duration = InfiniteBallsBooster.DEFAULT_DURATION_SECONDS )
  {
    super( CumulativeBoosterID.InfiniteBalls, duration, false );
  }

  protected override onActivate( context: InfiniteBallsBoosterContext ): void
  {
    context.setInfiniteBallsActive( true );
  }

  protected override onDeactivate( context: InfiniteBallsBoosterContext, _cancelled: boolean ): void
  {
    context.setInfiniteBallsActive( false );
  }
}
